export default {
  tripWireToInt: tripWireToInt,
  tripIntToWire: tripIntToWire,
};

function tripWireToInt (wireTrip) {
  if (!wireTrip || !wireTrip._attributes) return {};

  const { label, numOfSegments } = wireTrip._attributes;
  return {
    type: label,
    segments: numOfSegments ? parseInt(numOfSegments, 10) : 0,
  };
}

function tripIntToWire (intTrip) {
  const { type, segments } = intTrip;
  return {
    _attributes: {
      label: type,
      numOfSegments: segments,
    },
  };
}



// WEBPACK FOOTER //
// ./src/converter/TripConverter.js